module.exports = __webpack_public_path__ + "img/bar-chart.d980f811.svg";